
import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_HERO = gql`
  query MyQuery {
    homePage {
      hero {
        contentItems {
          ... on BackGroundSection {
            enabled
            media {
              urls
            }
            isVideo
          }
          ... on LeftSection {
            headLine
            tagLine
            enabled
            cTA1 {
              text
              url
            }
            cTA2 {
              text
              url
            }
            isCTA2
            isCTA1
          }
          ... on RightSection {
            title
            openDays
            openTimes
            enabled
          }
        }
      }
    }
  }
`;

export async function fetchHero() {
  const response = await apolloClient.query({
    query: GET_HERO,
    fetchPolicy: "network-only",
  });

  return response.data;
}
